import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { useParams } from "react-router-dom";
import CustomSelect from "../Form/CustomSelect";
import { MediaCard } from "../global/MediaCard";
import { productData } from "../../data/carousel";

export const SortedShopSection = ({ data }) => {
  let params = useParams();
  const [filteredData, setFilteredData] = React.useState([]);

  React.useEffect(() => {
    const filterProductData = () => {
      let result = [...data]; // Create a copy of the original data

      if (params.slug === "recently-added") {
        result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      } else if (params.slug === "best-seller") {
        result.sort((a, b) => b.count - a.count);
      } else if (params.slug === "deluxe-collection") {
        result.sort((a, b) => b.price - a.price);
      }
      // console.log("SLUG is", params.slug);
      setFilteredData(result);
    };

    filterProductData();
    // console.log("filteredData", filteredData);
  }, [params, params.slug, data]);

  const [page, setPage] = React.useState(1);
  const itemsPerPage = 8;
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleProducts = filteredData.slice(startIndex, endIndex);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <Box
      //   display={"flex"}
      //   alignItems={"center"}
      // justifyContent={"center"}
      className="w-full h-fit bg-white grid md:block px-12 lg:px-36 py-10"
    >
      <Box className="">
        <Box className="float-end">
          <Typography
            variant="body"
            fontWeight={300}
            fontSize={{ xs: "16px", sm: "15px", md: "16px" }}
            //   lineHeight={{ xs: "103%", sm: "155.5%" }}
            letterSpacing={"-0.05em"}
            color="primary"
            className="opacity-75"
          >
            {filteredData.length} results
          </Typography>
        </Box>
      </Box>
      {/* <hr className=" hidden md:block w-full border-[1px] border-grey-100 mb-8" /> */}

      <Grid container spacing={2}>
        {visibleProducts.map((item, index) => (
          <Grid item xs={12} sm={3} key={index}>
            <MediaCard
              imgSrc={item.imgSrc}
              title={item.name}
              path={`/shop/view/${item.slug}/${item.id}`}
              price={`£ ${item.price}`}
              priceColor={"primary"}
            />
          </Grid>
        ))}
      </Grid>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        className="py-10 md:py-20"
      >
        <Pagination
          count={Math.ceil(data.length / itemsPerPage)}
          page={page}
          // variant="outlined"
          shape="rounded"
          color="primary"
          // hidePrevButton
          // hideNextButton
          onChange={handlePageChange}
        />
      </Box>
    </Box>
  );
};
